import { QwickAI } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";

interface MatchBadgeProps extends React.ComponentProps<"div"> {
  matchPercentage: number;
  size?: "small" | "default";
}

export const MatchBadge: React.FC<MatchBadgeProps> = ({ matchPercentage, size = "default", className, ...props }) => (
  <div
    className={cn(
      "flex items-center gap-1 rounded-full bg-linear-to-r from-info to-brand px-2 py-0.5 whitespace-nowrap",
      className,
    )}
    {...props}
  >
    <QwickAI className={cn("shrink-0", size === "small" ? "size-2.5" : "size-3")} />
    <span
      className={cn(
        "leading-none tracking-tight text-white",
        size === "small" ? "text-small" : "text-normal font-semibold",
      )}
    >
      {matchPercentage}% Match
    </span>
  </div>
);
